// File for logic corresponding to header component
import { Component } from 'js-component-framework';
import './header.scss';

/**
 * Component for site header
 */
export default class Header extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    this.setupMobileNav();
  }

  setupMobileNav() {
    const {
      children: {
        drawer = null,
        drawerOpen = null,
      },
    } = this;

    if (drawer && drawerOpen) {
      drawerOpen.addEventListener('click', (e) => {
        e.preventDefault();

        if (drawer.classList.contains('show')) {
          this.hideNav();
        } else {
          this.showNav();
        }
      });
    }
  }

  setNavText() {
    const {
      children: {
        drawer = null,
        drawerOpen = null,
      },
    } = this;

    const status = drawer.classList.contains('show');

    if (status) {
      drawerOpen.innerText = 'en_US' === nbc.locale ? 'CLOSE' : 'Cerrar X';
    } else {
      drawerOpen.innerText = 'en_US' === nbc.locale ? 'MENU' : 'Menú';
    }
  }

  hideNav() {
    const {
      children: {
        drawer = null,
      },
    } = this;

    document.body.style.height = '';
    document.body.style.overflowY = '';

    drawer.classList.remove('show');
    this.setNavText();
  }

  showNav() {
    const {
      children: {
        drawer = null,
      },
    } = this;

    drawer.classList.add('show');
    this.setNavText();

    document.body.style.height = `${document.body.clientHeight}px`;
    document.body.style.overflowY = 'hidden';
  }
}
